module.exports = __webpack_public_path__ + "img/Slovenia.df574d1d.svg";